export default "__VITE_ASSET__Jwaz0N6L__"